import { COMPANY_TYPE } from '@constants/app';

function permissionConfig({ userAccess, permissionName }) {
  if (!permissionName) {
    throw Error('Permission Button requires a permission name');
  }

  let hasPermission = false;
  const role = userAccess?.role?.roleIdentifier;

  const isSASupervisor =
    userAccess?.company?.companyType === COMPANY_TYPE.SERVICE_ADMINISTRATOR &&
    role === 'SUPERVISOR';
  const isSACoordinator =
    userAccess?.company?.companyType === COMPANY_TYPE.SERVICE_ADMINISTRATOR &&
    role === 'COORDINATOR';
  const isSAReadOnly =
    userAccess?.company?.companyType === COMPANY_TYPE.SERVICE_ADMINISTRATOR &&
    role === 'READONLY';

  const isSPManager =
    userAccess?.company?.companyType === COMPANY_TYPE.SERVICE_PROVIDER &&
    role === 'MANAGER';
  const isSPReadonly =
    userAccess?.company?.companyType === COMPANY_TYPE.SERVICE_PROVIDER &&
    role === 'READONLY';

  const isAdminImplementationManager =
    userAccess?.company?.companyType === COMPANY_TYPE.ADMIN &&
    role === 'IMPLEMENTATION_MANAGER';

  if (isSASupervisor || isAdminImplementationManager) {
    switch (permissionName) {
      case 'CAN_UPDATE_SA_PASSWORD': {
        hasPermission = !userAccess?.isSSO();
        break;
      }
      case 'CAN_RESET_SA_USER_MFA': {
        hasPermission = !userAccess?.isSSO();
        break;
      }
      case 'CAN_SEND_SA_RESET_PASSWORD_EMAIL': {
        hasPermission = !userAccess?.isSSO();
        break;
      }
      case 'CAN_UPDATE_SELF_PASSWORD': {
        hasPermission = !userAccess?.isSSO();
        break;
      }
      case 'CAN_RESET_SELF_USER_MFA': {
        hasPermission = !userAccess?.isSSO();
        break;
      }
      case 'CAN_CREATE_EDIT_SYSTEM_SETTINGS_PAGES': {
        hasPermission = isAdminImplementationManager;
        break;
      }
      default: {
        hasPermission = true;
        break;
      }
    }
  } else {
    switch (permissionName) {
      case 'CAN_EXPORT_SERVICE_JOBS': {
        hasPermission = true;
        break;
      }
      case 'CAN_CREATE_SP': {
        hasPermission = false;
        break;
      }
      case 'CAN_LIST_SP': {
        hasPermission = isSACoordinator || isSAReadOnly;
        break;
      }
      case 'CAN_UPDATE_SP': {
        hasPermission = isSACoordinator;
        break;
      }
      case 'CAN_SEARCH_SP': {
        hasPermission = isSACoordinator || isSAReadOnly;
        break;
      }
      case 'CAN_UPDATE_SP_BASIC_INFO': {
        hasPermission = isSACoordinator || isSPManager;
        break;
      }
      case 'CAN_UPDATE_SP_BASIC_INFO_STATUS': {
        hasPermission = isSACoordinator;
        break;
      }
      case 'CAN_CREATE_SP_LOCATIONS': {
        hasPermission = isSPManager || isSACoordinator;
        break;
      }
      case 'CAN_LIST_SP_LOCATIONS': {
        hasPermission =
          isSACoordinator || isSAReadOnly || isSPManager || isSPReadonly;
        break;
      }
      case 'CAN_SEARCH_SP_LOCATIONS': {
        hasPermission =
          isSACoordinator || isSAReadOnly || isSPManager || isSPReadonly;
        break;
      }
      case 'CAN_UPDATE_SP_LOCATIONS': {
        hasPermission = isSACoordinator || isSPManager;
        break;
      }
      case 'CAN_UPDATE_SP_SKILLS': {
        hasPermission = isSACoordinator || isSPManager;
        break;
      }
      case 'CAN_ADD_SP_INSIGHT_CONTACTS': {
        hasPermission = isSACoordinator || isSPManager;
        break;
      }
      case 'CAN_UPDATE_SP_NOTIFICATION_PREFERENCES': {
        hasPermission = isSACoordinator || isSPManager;
        break;
      }
      case 'CAN_UPDATE_SP_MODULE_SETTINGS_CLAIMS': {
        hasPermission = isSACoordinator;
        break;
      }
      case 'CAN_UPDATE_SP_MODULE_SETTINGS_DISPATCH': {
        hasPermission = isSACoordinator;
        break;
      }
      case 'CAN_UPDATE_SP_MODULE_SETTINGS_INSIGHT': {
        hasPermission = isSACoordinator;
        break;
      }
      case 'CAN_CREATE_API_KEY': {
        hasPermission = isSASupervisor || isAdminImplementationManager;
        break;
      }
      case 'CAN_UPDATE_SP_RATECARD': {
        hasPermission = isSACoordinator || isSPManager;
        break;
      }
      case 'CAN_UPDATE_SP_PERFORMANCE': {
        hasPermission = isSACoordinator;
        break;
      }
      case 'CAN_CREATE_SP_USER': {
        hasPermission = isSACoordinator || isSPManager;
        break;
      }
      case 'CAN_UPDATE_SP_USER': {
        hasPermission = isSACoordinator || isSPManager;
        break;
      }
      case 'CAN_LIST_SP_USER': {
        hasPermission =
          isSACoordinator || isSAReadOnly || isSPManager || isSPReadonly;
        break;
      }
      case 'CAN_SEARCH_SP_USER': {
        hasPermission =
          isSACoordinator || isSAReadOnly || isSPManager || isSPReadonly;
        break;
      }
      case 'CAN_UPDATE_SP_SELF_PROFILE': {
        hasPermission = true;
        break;
      }
      case 'LIST_JOBS': {
        hasPermission =
          isSACoordinator || isSAReadOnly || isSPManager || isSPReadonly;
        break;
      }
      case 'CREATE_JOB': {
        hasPermission = isSACoordinator;
        break;
      }
      case 'SEARCH_JOB': {
        hasPermission =
          isSACoordinator || isSAReadOnly || isSPManager || isSPReadonly;
        break;
      }
      case 'UPDATE_JOB': {
        hasPermission = isSACoordinator;
        break;
      }
      case 'DUPLICATE_JOB': {
        hasPermission = isSACoordinator;
        break;
      }
      case 'DELETE_SERVICE_REQUESTED_IN_JOB': {
        hasPermission = isSACoordinator;
        break;
      }
      case 'ADD_SERVICE_REQUESTED_IN_JOB': {
        hasPermission = isSACoordinator;
        break;
      }
      case 'CAN_CREATE_SP_PASSWORD': {
        hasPermission = true;
        break;
      }
      case 'CAN_UPDATE_SP_PASSWORD': {
        hasPermission =
          (isSPManager && !userAccess?.isSSO()) || isSACoordinator;
        break;
      }
      case 'CAN_RESET_SP_USER_MFA': {
        hasPermission =
          (isSPManager && !userAccess?.isSSO()) || isSACoordinator;
        break;
      }
      case 'CAN_SEND_SP_RESET_PASSWORD_EMAIL': {
        hasPermission =
          (isSPManager && !userAccess?.isSSO()) || isSACoordinator;
        break;
      }
      case 'CAN_UPDATE_SA_PASSWORD': {
        hasPermission = false;
        break;
      }
      case 'CAN_RESET_SA_USER_MFA': {
        hasPermission = false;
        break;
      }
      case 'CAN_SEND_SA_RESET_PASSWORD_EMAIL': {
        hasPermission = false;
        break;
      }
      case 'CAN_UPDATE_SELF_PASSWORD': {
        hasPermission = !userAccess?.isSSO();
        break;
      }
      case 'CAN_RESET_SELF_USER_MFA': {
        hasPermission = !userAccess?.isSSO();
        break;
      }
      case 'SEARCH_CLAIM': {
        hasPermission = true;
        break;
      }
      case 'CAN_CREATE_USER': {
        hasPermission = false;
        break;
      }
      case 'CAN_ADD_NEW_CLAIM': {
        hasPermission = isSACoordinator || isSPManager;
        break;
      }
      case 'CAN_UPDATE_APPOINTMENT_DATE': {
        hasPermission = isSPManager;
        break;
      }
      case 'CAN_UPDATE_JOB_FROM_MAP': {
        hasPermission = isSACoordinator;
        break;
      }
      case 'CAN_CREATE_EDIT_USER': {
        hasPermission = isSPManager;
        break;
      }
      case 'CAN_CREATE_EDIT_MAINTENANCE_PAGES': {
        hasPermission = false;
        break;
      }
      case 'CAN_CREATE_EDIT_SYSTEM_SETTINGS_PAGES': {
        hasPermission = false;
        break;
      }
      case 'CAN_UPDATE_SP_STATUS': {
        hasPermission = isSACoordinator;
        break;
      }
      case 'CAN_CREATE_SP_API_KEY': {
        hasPermission = isSASupervisor || isAdminImplementationManager;
        break;
      }
      default:
        throw Error(
          `Permission Button: permission is not setup for ${permissionName}`,
        );
    }
  }

  if (!hasPermission) {
    return false;
  }
  return hasPermission;
}

export default permissionConfig;
